;(function () {
    function FilterReopenCollapse(filters) {
        /**
         * local object availability
         * @type {FilterReopenCollapse}
         * @private
         */
        var _this = this

        /**
         * jQuery object of all filter buckets - in this case these are all collapsibles
         *
         * @type {jQuery}
         * @private
         */
        this.searchFilterBuckets = filters.find('.js-filter-bucket')

        /**
         * Save the last opened bucket in the local storage
         *
         * @method saveLastOpenedBucketCollapse
         * @param {string} bucketId The id of the bucket that has been opened
         * @returns {undefined}
         */
        this.saveLastOpenedBucketCollapse = function (bucketId) {
            localStorage.setItem('lastOpenedBucket', bucketId)
        }

        /**
         * Remove the last opened bucket from the local storage
         *
         * @method removeLastOpenedBucketCollapse
         * @returns {undefined}
         */
        this.removeLastOpenedBucketCollapse = function () {
            localStorage.removeItem('lastOpenedBucket')
        }

        /**
         * Bind the show event of a buckets collapse
         *
         * @method bindCollapseShowEvent
         * @returns {undefined}
         */
        this.bindCollapseShowEvent = function () {
            _this.searchFilterBuckets.on('shown.bs.collapse', function () {
                var bucketId = $(this).attr('id')
                _this.saveLastOpenedBucketCollapse(bucketId)
                // we remove the no-transition class, the initially opened bucket has this class to prevent a opening animation
                $(this).removeClass('no-transition')
            })
        }

        /**
         * Bind the hide event of a buckets collapse
         *
         * @method bindCollapseHideEvent
         * @returns {undefined}
         */
        this.bindCollapseHideEvent = function () {
            _this.searchFilterBuckets.on('hide.bs.collapse', function () {
                _this.removeLastOpenedBucketCollapse()
            })
        }

        /**
         * Open the last opened bucket initially
         *
         * @method openLastOpenedBucketCollapse
         * @returns {undefined}
         */
        this.openLastOpenedBucketCollapse = function () {
            var lastOpenedBucket = localStorage.getItem('lastOpenedBucket')
            if (lastOpenedBucket) {
                var toOpenBucket = filters.find('#' + lastOpenedBucket)
                // add the no-transition class to prevent the lengthy animation on page load, this class gets removed
                // immediately after it has been opened so that users initiated opens have a animation
                toOpenBucket.addClass('no-transition')
                toOpenBucket.collapse('show')
            }
        }

        /**
         * Open the last opened bucket and bind events to the bucket
         *
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            _this.openLastOpenedBucketCollapse()
            _this.bindCollapseHideEvent()
            _this.bindCollapseShowEvent()
        }

        /**
         * initial call
         */
        _this.init()
    }

    window.FilterReopenCollapse = window.FilterOverlay || {}

    window.FilterReopenCollapse.FilterReopenCollapse = FilterReopenCollapse
})()

$(document).ready(function () {
    // event though we have decided to not use the rel attribute to select elements from js, this is used here to be
    // consistent with the old js files that are also referencing this element by the rel attribute
    var overlay = $('[rel="search-filters"]')

    if (overlay) {
        new window.FilterReopenCollapse.FilterReopenCollapse(overlay)
    }
})
